import React, { useState, useEffect } from "react";
import ViewIncoice from "../../../../../entities/DashboardPage/AccountingModule/Invoice/InvoiceView";
import AuthService from "../../../../../api/AuthService";
import LoaderHelper from "../../../../../utils/Loader/LoaderHelper";
import { useLocation } from "react-router-dom";
import { useAlert } from "../../../../../context/AlertContext";
import { salaryService } from "../../../../../api";
import QuoteView from "../../../../../entities/DashboardPage/AccountingModule/Quotes/QuotesView";

const ViewQuotes = () => {
  const { showAlert } = useAlert();
  const { state } = useLocation();
  const { rowItem, page } = state || {}; // Destructure 'item' from state
  const { flag, id } = rowItem || {};
  const [loading, setLoading] = useState(false);

  const handleDownload = async () => {
    LoaderHelper.loaderStatus(true);

    setLoading(true)
    try {
      const result = await AuthService.handleDownloadQuote(rowItem?._id);
      if (!result) {
        setLoading(false);
        LoaderHelper.loaderStatus(false);
        showAlert(result?.message, "error");
      } else {
        const blob = new Blob([result], { type: "application/pdf" });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `FileName.${"pdf"}`);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
        setLoading(false);

        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  const getViewInvoice = async () => {
    const result = await AuthService.getQuoteView(rowItem?._id);
    return { __html: result };
  };

  const sentQuote = async () => {
    LoaderHelper.loaderStatus(true);
    setLoading(true)
    try {
      const result = await AuthService.sentQuote(rowItem?._id);
      if (result?.success === true) {
        getViewInvoice();
        setLoading(false)
        LoaderHelper.loaderStatus(false);
        showAlert(result?.message, "success");
      } else {
        setLoading(false)
        LoaderHelper.loaderStatus(false);

        showAlert(result?.message, "error");
      }
    } catch (error) {
      setLoading(false)
      LoaderHelper.loaderStatus(false);
    }
  };

  // const paidInvoice = async (bankId, type, invoicePayDate) => {
  //   LoaderHelper.loaderStatus(true);
  //   setLoading(true)
  //   try {
  //     const result = await AuthService.paidInvoice(item?._id, bankId, type, invoicePayDate);
  //     if (result?.success === true) {
  //       setLoading(false)
  //       LoaderHelper.loaderStatus(false);

  //       getInvoice("", "", page)
  //       showAlert(result?.message, "success");
  //     } else {
  //       setLoading(false)
  //       LoaderHelper.loaderStatus(false);
  //       showAlert(result?.message, "error");
  //     }
  //   } catch (error) {
  //     setLoading(false)
  //     LoaderHelper.loaderStatus(false);
  //     }
  // };

  // const handleShowPdf = async () => {
  //   const result = await salaryService.showPdf(id);
  //   return { __html: result };
  // };

  // const getAllBanks = async () => {
  //   LoaderHelper.loaderStatus(true);
  //   try {
  //     const result = await AuthService.handleGetAllCompanyBankAccount();
  //     if (result?.success) {
  //       setData(result?.data?.bankAccounts);
  //       LoaderHelper.loaderStatus(false);
  //     } else {
  //       LoaderHelper.loaderStatus(false);
  //     }
  //   } catch (error) {
  //     LoaderHelper.loaderStatus(false);
  //   }
  // };

  // const getInvoice = async (text, sort, page) => {
  //   LoaderHelper.loaderStatus(true);

  //   try {
  //     const result = await AuthService.getInvoice(text, sort, page);
  //     if (result?.success) {
  //       const matchedInvoice = result?.data?.invoices?.find(invoice => invoice._id === item?._id);
  //       if (matchedInvoice) {
  //         setInvoiceData(matchedInvoice);
  //       }
  //       LoaderHelper.loaderStatus(false);
  //     } else {
  //       LoaderHelper.loaderStatus(false);
  //     }
  //   } catch (error) {
  //     LoaderHelper.loaderStatus(false);
  //   }
  // };

  // const getReceiptView = async () => {
  //   const result = await AuthService.getReceiptView(invoiceData?.receiptId);
  //   return { __html: result };
  // };

  // const handleDownloadReceipt = async () => {
  //   LoaderHelper.loaderStatus(true);

  //   setLoading(true)
  //   try {
  //     const result = await AuthService.handleDownloadReceipt(invoiceData?.receiptId);
  //     if (!result) {
  //       setLoading(false);
  //       LoaderHelper.loaderStatus(false);
  //       showAlert(result?.message, "error");
  //     } else {
  //       const blob = new Blob([result], { type: "application/pdf" });
  //       const url = window.URL.createObjectURL(blob);
  //       const link = document.createElement("a");
  //       link.href = url;
  //       link.setAttribute("download", `FileName.${"pdf"}`);
  //       document.body.appendChild(link);
  //       link.click();
  //       link.parentNode.removeChild(link);
  //       setLoading(false);

  //       LoaderHelper.loaderStatus(false);
  //     }
  //   } catch (error) {
  //     LoaderHelper.loaderStatus(false);
  //   }
  // };

  // const handleSentReceipt = async () => {
  //   LoaderHelper.loaderStatus(true);
  //   setLoading(true)
  //   try {
  //     const result = await AuthService.handleSentReceipt(invoiceData?.receiptId);
  //     if (result?.success === true) {
  //       setLoading(false)
  //       LoaderHelper.loaderStatus(false);
  //       getInvoice("", "", page);
  //       showAlert(result?.message, "success");
  //     } else {
  //       setLoading(false)
  //       LoaderHelper.loaderStatus(false);

  //       showAlert(result?.message, "error");
  //     }
  //   } catch (error) {
  //     setLoading(false)
  //     LoaderHelper.loaderStatus(false);
  //   }
  // };

  return (
    <QuoteView handleDownload={handleDownload} getViewInvoice={getViewInvoice} sentQuote={sentQuote} rowItem={rowItem} />
  )

}

export default ViewQuotes;
